
<div class="customers">
    <div class="d-flex">
        <button type="button" class="btn btn-volver mr-auto p-2" (click)="volver()">VOLVER</button>
        <div *ngIf="faseEstrategicaData.estado < 2 && !simulacion">
            <button type="button" class="btn btn-guardar p-2" (click)="guardarFaseEstrategica()">GUARDAR AVANCES</button>
            <button type="button" class="btn btn-enviar p-2" (click)="validarFinalizar()">FINALIZAR Y ENVIAR</button>
        </div>
    </div>
    <div class="card" style="padding: 1rem;">
        <div class="card-body" style="padding: 20px;">
            <div class="row">
                <div class="d-flex justify-content-between">
                    <div>
                        <p style="text-align: left;
                            font: normal normal bold 26px/53px Montserrat;
                            letter-spacing: 0px;
                            color: #00B09E;
                            opacity: 1;">Fase Estratégica</p>
                    </div>
                    <div class="" style="text-align: left;">
                        <div class="d-flex justify-content-end" style="background: #F6F6F6 0% 0% no-repeat padding-box;
                        border-radius: 10px;
                        opacity: 1;
                        padding: 15px;
                        ">
                            <p class="info-label">JARDÍN INFANTIL: </p>

                            <p class="info-data">{{dataJardin.jardin}}</p>

                            <p class="info-label">CÓDIGO: </p>

                            <p class="info-data">{{dataJardin.rbd}}</p>

                            <p class="info-label">PERIODO: </p>

                            <p class="info-data">{{getPeriodoJardin(dataJardin.tipoJardin)}}</p>

                        </div>
                    </div>
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col-sm-12">
                    <p style="font: normal normal 600 14px/18px Montserrat;
                    letter-spacing: 0px;
                    color: #30374B;
                    text-transform: uppercase;
                    display: inline-block;
                    opacity: 1;">
                        OBJETIVOS ESTRATÉGICOS:
                    </p>
                    <p style="text-align: left;
                        letter-spacing: 0px;
                        color: #30374B;
                        opacity: 1;"><b></b></p>
                    <p style="text-align: left;
                        letter-spacing: 0px;
                        color: #30374B;
                        opacity: 1;">Constituyen el desafío que los establecimientos pretenden abordar durante los 4 años de duración de sus PME en cada una de las dimensiones de gestión en Educación Parvularia (EID EP).</p>
                </div>
            </div>
            <br>
            <div #divSpinner class="cargando" [style.display]="cargando ? '' : 'none'">
                <mat-spinner style="margin-top: 15%;margin-left: 35vw;"></mat-spinner>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div *ngFor="let dimensionData of faseEstrategicaData.dimensiones; let indice=index">
                        <app-pme-dimensiones [estadoData]="faseEstrategicaData.estado" [dimensionData]="dimensionData" [dataJardin]="dataJardin" [simulacion]="simulacion"></app-pme-dimensiones>
                    </div>
                </div> 
            </div>
            <br>
        </div>
    </div>
</div>